import PropTypes from 'prop-types';
import { fieldInputPropTypes, fieldMetaPropTypes } from 'redux-form';
var formGroupCommonPropTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  classConfig: PropTypes.shape({
    label: PropTypes.string,
    input: PropTypes.string
  }),
  validate: PropTypes.oneOfType([PropTypes.func, PropTypes.arrayOf(PropTypes.func)]),
  wrapperClassName: PropTypes.string,
  helpText: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};
var formGroupCommonDefaultProps = {
  label: null,
  classConfig: {
    label: '',
    input: '',
    selectField: '',
    inputField: '',
    helpText: ''
  },
  validate: null,
  wrapperClassName: undefined,
  helpText: null
};
var renderFormGroupCommonPropTypes = {
  input: PropTypes.shape(fieldInputPropTypes).isRequired
};
var formGroupPropTypes = {
  type: PropTypes.string.isRequired,
  autocomplete: PropTypes.string,
  autofocus: PropTypes.bool,
  placeholder: PropTypes.string,
  wrapperClassName: PropTypes.string,
  readOnly: PropTypes.bool
};
var formGroupDefaultProps = {
  autocomplete: null,
  autofocus: false,
  placeholder: '',
  wrapperClassName: undefined
};
var formGroupCodePropTypes = {
  type: PropTypes.string.isRequired,
  autocomplete: PropTypes.string,
  autofocus: PropTypes.bool,
  maxLength: PropTypes.number
};
var formGroupCodeDefaultProps = {
  autocomplete: null,
  autofocus: false,
  maxLength: null
};
var formGroupSelectPropTypes = {
  placeholderOption: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    id: PropTypes.string
  }))
};
var formGroupSelectDefaultProps = {
  placeholderOption: null,
  options: null
};
var formGroupTextareaPropTypes = {
  autofocus: PropTypes.bool,
  placeholder: PropTypes.string,
  rows: PropTypes.string
};
var formGroupTextareaDefaultProps = {
  autofocus: false,
  placeholder: null,
  rows: null
};
var formGroupCheckboxPropTypes = {
  input: PropTypes.shape(fieldInputPropTypes).isRequired,
  meta: PropTypes.shape(fieldMetaPropTypes).isRequired,
  label: PropTypes.node,
  classConfig: PropTypes.shape({
    label: PropTypes.string,
    input: PropTypes.string
  }),
  wrapperClassName: PropTypes.string,
  disabled: PropTypes.bool,
  muteError: PropTypes.bool
};
var formGroupCheckboxDefaultProps = {
  label: null,
  classConfig: {
    label: '',
    input: ''
  },
  wrapperClassName: 'checkbox',
  disabled: false,
  muteError: false
};
var formGroupRadioPropTypes = {
  input: PropTypes.shape(fieldInputPropTypes).isRequired,
  meta: PropTypes.shape(fieldMetaPropTypes).isRequired,
  value: PropTypes.string.isRequired,
  label: PropTypes.string,
  classConfig: PropTypes.shape({
    label: PropTypes.string,
    input: PropTypes.string
  }),
  wrapperClassName: PropTypes.string,
  disabled: PropTypes.bool,
  muteError: PropTypes.bool
};
var formGroupRadioDefaultProps = {
  label: null,
  classConfig: {
    label: '',
    input: ''
  },
  wrapperClassName: 'radio',
  disabled: false,
  muteError: false
};
export { formGroupCommonPropTypes, formGroupCommonDefaultProps, renderFormGroupCommonPropTypes, formGroupPropTypes, formGroupDefaultProps, formGroupCodePropTypes, formGroupCodeDefaultProps, formGroupSelectPropTypes, formGroupSelectDefaultProps, formGroupTextareaPropTypes, formGroupTextareaDefaultProps, formGroupCheckboxPropTypes, formGroupCheckboxDefaultProps, formGroupRadioPropTypes, formGroupRadioDefaultProps };